import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

const $http = new APIManager();

const Api = {
  /**
   * [GETS] MessageHistory
   * --
   */
  getMessageHistories: async (params) => {
    try {
      const res = await $http.get(APIConstant.GETS_MESSAGE_HISTORY, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] MessageHistory
   * --
   */
  getMessageHistory: async (idx, params) => {
    try {
      const url = parameterToPath(APIConstant.GET_MESSAGE_HISTORY, {
        message_history_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] MessageHistory
   * --
   */
  createMessageHistory: async (body) => {
    try {
      const res = await $http.post(APIConstant.CREATE_MESSAGE_HISTORY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] MessageHistory
   * --
   */
  updateMessageHistory: async (body) => {
    try {
      const { message_history_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_MESSAGE_HISTORY, {
        message_history_id: message_history_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] MessageHistory
   * --
   */
  deleteMessageHistory: async (idx) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_MESSAGE_HISTORY, {
        message_history_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
